<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-plan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 42a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h34zM20.118 1.882a2 2 0 011.049.296L41.35 14.6a2 2 0 010 3.407L22 29.913V36h14a1 1 0 011 1v2a1 1 0 01-1 1H12a1 1 0 01-1-1v-2a1 1 0 011-1h6V19h.118V3.882a2 2 0 012-2zm2 5.579v17.683l14.368-8.841L22.118 7.46z"/></svg>
</template>
<script>

export default {
  name: 'IconPlan',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
